// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-address-dialog-wrap .w-75[data-v-5e61ba69] {\n  min-width: 75px;\n}\n.edit-address-dialog-wrap .confirm-address .el-button[data-v-5e61ba69] {\n  width: 125px;\n  margin: 0 20px;\n}\n.edit-address-dialog-wrap .confirm-address .el-button--primary[data-v-5e61ba69] {\n  background: #e84c3d;\n  border: none;\n}\n", ""]);
// Exports
module.exports = exports;
